var fn_aside = function () {

    var screensize = $(window).width();

    if (screensize <= 992) {
        //
        if ($.trim($('.region-sidebar-first').html()).length) {

            $('.region-sidebar-first').before('<button type="button" class="aside-filter-mobile--button" id="asideFilterItem" aria-controls="aside-filter-item" aria-expanded="false">Filtres</button>')
            $('.region-sidebar-first').attr('aria-labelledby', 'asideFilterItem').attr('id', 'aside-filter-item').addClass('aside-filter-mobile--wrapper');

            $(document).on('click', '.aside-filter-mobile--button', function (e) {
                e.preventDefault();

                if ($(this).hasClass('open')) {
                    $(this).attr('aria-expanded', 'false').removeClass('open');
                    $(this).next().removeClass('open');
                } else {
                    $(this).attr('aria-expanded', 'true').addClass('open');
                    $(this).next().addClass('open');
                }
            });

        }
        // //
    } else {
        //
        if ($.trim($('.region-sidebar-first').html()).length) {

            $('.aside-filter-mobile--button').remove();
            $('.region-sidebar-first').removeAttr('aria-labelledby', 'asideFilterItem').removeAttr('id', 'aside-filter-item').removeClass('aside-filter-mobile--wrapper');

        }
        // //
    }

}
